import _ from 'underscore';
import Backbone from 'backbone';
import SessionGroup from './SessionGroup';
import SessionsGroupCollection from './SessionsGroupCollection';
import Track from './Track';
import Session from './Session';
import '../backbone-relational-isomorphic';

var Day = Backbone.RelationalModel.extend({
    relations: [
        {
            type: Backbone.HasMany,
            key: 'parsedSessions', // parsed by time
            relatedModel: SessionGroup,
            collectionType: SessionsGroupCollection
        },
        {
            type: Backbone.HasMany,
            key: 'parsedSessionsTracks',
            relatedModel: SessionGroup,
            collectionType: SessionsGroupCollection
        },
        {
            type: Backbone.HasMany,
            key: 'track',
            relatedModel: Track,
            collectionType: Backbone.Collection
        },
        {
            type: Backbone.HasMany,
            key: 'session',
            relatedModel: Session,
            collectionType: Backbone.Collection
        }
    ]
});

export default Day;

